<template>
  <div>
    <div class="banner">
      <div class="banner-background">
        <div class="banner-content">  
          <p class="p-one"><span class="span-line"></span>COURT</p>
          <p class="p-two">直通互联网法院-网络取证</p>
<!--          <p class="p-three" style="margin-bottom:10px">网页截屏方式固化证据</p>-->
<!--          <p class="p-three">版权区块链上链记录、取证证据直通互联网法院</p>-->
          <p class="p-three" style="width: 660px;font-size: 20px;">版权取证后，将截取的网页及时上传至区块链 ，可永久固定证据。</p>
          <button class="btn-138"  @click="goquzheng">去取证</button>
        </div>
      </div>
    </div>

    <div class="center-content">
      <ul>
        <li style="margin-left:55px">  
          <img src="./images/1.png" class="img1">            
          <p>国家授时中心授时，版权区块链，准</p>
          <p>确，不可修改性，取证司法认可</p>
        </li>
        <li style="margin:0 100px">  
          <img src="./images/2.png" class="img2" >            
          <p>智能全自动取证，网页取证、录屏取</p>
          <p>证等多种取证方式，使证据更完整</p>
        </li>
        <li>  
          <img src="./images/3.png" class="img3">            
          <p>实时监测、秒级取证，及时取证，便</p>
          <p>捷高效</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
      title: '取证介绍|时尚知识产权保护平台',
      meta: [{                 // set meta
          name: 'keyWords',
          content: ''
      },{
          name: 'Description',
          content: ''
      }]
  },
  name: "evidence",
  methods:{
    goquzheng(){
      this.$router.push({ path:'/evidenceWeb' })
    }
  }
  
};
</script>

<style scoped lang="less">
.banner{
  width:100%;
  height:460px;
  .banner-background{
    height:460px;
    background: #121210;
    .banner-content{
      width:1334px;
      height:460px;
      margin:0 auto;
      background: url("./images/bg.png") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      position: relative;
      overflow: hidden;
      .p-one{
        font-size:20px;
        font-weight:300;
        color:rgba(255,255,255,1);
        line-height:28px;
        letter-spacing:2px;
        margin:78px 0px 10px;
        .span-line{
          display: inline-block;
          width:70px;
          height:1px;
          background: #fff;
          vertical-align: middle;
          margin-right: 15px;
        }
      }
      .p-two{
        font-size:50px;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:70px;
        letter-spacing:6px;
        margin-bottom: 25px; 
      }
      .p-three{
        font-size:25px;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:34px;
        letter-spacing:10px;
      }
      .btn-138{
        width:138px;
        height:42px;
        line-height: 42px;
        border:0;
        outline: none;
        background:rgba(255,255,255,1);
        border-radius:2px;
        font-size:14px;
        font-weight:bold;
        color:rgba(43,33,70,1);
        cursor: pointer;
        margin-top:39px;
      }
      img{
        width: 766px;
        height: 437px;
        position: absolute;
        top:22px;
        left:517px;
      }
    }
  }
}
.center-content{
  width:1334px;
  height:501px;
  margin:0 auto;
  ul{
    overflow: hidden;
    padding-top:136px;
    li{
      float: left;
      width:341px;
      height:260px;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
      list-style: none;
      text-align: center;
      overflow: hidden;
      .img1{
        width: 44px;
        height: 36px;
        margin:48px 0 22px;
      }
      .img2{
        width: 45px;
        height: 41px;
        margin:45px 0 19px;
      }
      .img3{
        width: 49px;
        height: 45px;
        margin:41px 0 18px;
      }
      p{
        font-size:16px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:28px;
      }
    }
  }
}
</style>
